import { useCallback } from 'react';
import { unwrapResult } from '@reduxjs/toolkit';
import type {
  GenerateProductCategorySuggestionsRequestDto,
  GenerateProductCategorySuggestionsResponseDto,
} from '@tiendanube/common';
import { useAppDispatch } from 'App/store';
import { generateProductCategorySuggestions } from '../../../productsSlice';

function useGenerateProductCategorySuggestions() {
  const dispatch = useAppDispatch();

  const generateCategorySuggestions = useCallback(
    async (
      requestDto: GenerateProductCategorySuggestionsRequestDto,
    ): Promise<GenerateProductCategorySuggestionsResponseDto> => {
      const result = await dispatch(
        generateProductCategorySuggestions(requestDto),
      );
      return unwrapResult(result);
    },
    [dispatch],
  );

  return { generateCategorySuggestions };
}

export default useGenerateProductCategorySuggestions;
